if ($('#calendly-vue').length) {
    var app = new Vue({
        el: '#calendly-vue',
        methods: {
            getCalendly() {
                axios.get('/tracking/book-a-demo', {
                    params: {
                        path: location.pathname
                    }
                })
                    .then((response) => {
                        Calendly.initPopupWidget({
                            url: 'https://calendly.com/hayley-leo/introduction-to-the-leo-platform',
                            event: 'calendly.event_scheduled'
                        });
                        return false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
            }
        }
    });
}